<template>
    <div id="app" v-cloak>
        <transition name="component-fade" mode="out-in">
            <keep-alive>
            <router-view v-if="istrue == true" />
            </keep-alive>
        </transition>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                resizeTimer: null,
                istrue: false
            }
        },
        methods: {
            isWindow () {
                // 强制设定body高度为窗口高度
                let doc = document.documentElement
                document.body.style.height = doc.scrollHeight + 'px'
            },
            renderResize() {
                let that = this
                that.istrue = false
                // 判断横竖屏
                let width = document.documentElement.clientWidth
                let height = document.documentElement.clientHeight

                if (that.resizeTimer) clearTimeout(that.resizeTimer)
                that.resizeTimer = setTimeout(() => {
                    // 横屏
                    if(width > height) {
                        that.$store.commit('setScreen', 10)
                    // 竖屏
                    } else {
                        that.$store.commit('setScreen', 1)
                    }
                    that.istrue = true
                } , 300)
                // 注意：renderResize 方法执行时虚拟 dom 尚未渲染挂载，如果要操作 vue 实例，最好在this.$nextTick()里进行。
            }
        },
        created () {
            // this.isWindow()
            this.renderResize()
        },
        mounted () {
            // 监听 resize 方法
            window.addEventListener("resize", this.renderResize, false)
        }
    }
</script>

<style>
[v-cloak] {
    display: none !important;
}
    html, body {
        width: 100%;
        height: 100%;
        color: #fff;
        overflow: hidden;
        /* 消除ios点击按钮时出现的一个半透明的灰色背景 */
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        
        /* 禁止复制 */
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        /* 消除transition闪屏 */
        transform-style: preserve-3d;
        backface-visibility: hidden;
        perspective: 1000;
        -webkit-transform-style: preserve-3d;
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;

        /* 当检测到某个DOM元素应用了某些CSS规则时就会自动开启，从而解决页面闪白，保证动画流畅。 */
        -webkit-transform: translate3d(0,0,0);
        -moz-transform: translate3d(0,0,0);
        -ms-transform: translate3d(0,0,0);
        transform: translate3d(0,0,0);
    }
    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }
    ::-webkit-scrollbar {
        display: none;
    }
    #app {
        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
